import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** «Egil Sønstabø» → «Egil» – how a colleague would address you. */
export const firstName = (name) => (name || "").trim().split(/\s+/)[0] || "";
